import React, { useState, useEffect, useCallback } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { Panel, PanelHeader } from './../../../../components/panel/panel.jsx'
import { compose } from 'recompose'
import { withStores, withHooks } from '../../../../enhancers/index.js'
import ReactTable from 'react-table'
import 'react-table/react-table.css'

const tableColumns = [
  {
    Header: 'Year',
    accessor: 'year',
  },
]

const MortalityBaseTable = props => (
  <div>
    <ol className="breadcrumb float-xl-right">
      <li className="breadcrumb-item">
        <Link to="/">Mortality Base Table</Link>
      </li>
    </ol>
    <h1 className="page-header">Mortality Base Table</h1>
    <Panel>
      <PanelHeader noButton={true}>
        Mortality Base Table{' '}
        <button
          type="button"
          className="btn btn-success m-l-15"
          onClick={props.goToNewPage}
        >
          new
        </button>
      </PanelHeader>

      <ReactTable
        filterable
        data={props.all}
        columns={tableColumns}
        className="-highlight"
        defaultPageSize={10}
        getTrProps={props.goToEditPage}
      />
    </Panel>
  </div>
)

const enhancer = compose(
  withRouter,
  withStores(stores => ({
    fetch: stores.mortalityBaseStore.fetch,
    all: stores.mortalityBaseStore.all,
  })),

  withHooks(props => {
    const [loading, setLoading] = useState(false)

    useEffect(() => {
      props.fetch()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const goToEditPage = useCallback((state, rowInfo) => {
      return {
        onClick: e => {
          props.history.push(
            `/score_star/mortality_base/${rowInfo.original.id}`
          )
        },
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const goToNewPage = useCallback(
      () => props.history.push('/score_star/mortality_base/new'),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    )

    return { loading, setLoading, goToEditPage, goToNewPage }
  })
)

export default enhancer(MortalityBaseTable)
